/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import PaymentType from '../../forms/paymentType';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';

import {
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  AddBox,
  StyledCrudTable,
  FormHelperText,
  PaymentIcon,
} from './styles';
import { isEmpty } from 'lodash';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';

const SelectPaymentTypeDialogControl = ({
  data,
  className,
  id,
  enabled = true,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible = true,
  disabled,
  required,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = React.useState({});

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({});
  const [searchBy, setSearchBy] = useState('');

  const columns = PaymentType.tableSchema;

  useEffect(() => {
    restApiClient.paymentType
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .like('id', searchBy)
              .or()
              .like('name', searchBy)
              .toString()
          : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.paymentType.findById(data).then((e) => {
        setSelectedPaymentType(e.data);
        if (path) {
          const pathArray = path.split('.');
          pathArray.pop();
          if (pathArray.length > 0) {
            handleChange?.(
              `${pathArray.join('.')}.paymentTypeName`,
              e.data.name
            );
          }
        }
      });
    } else {
      setSelectedPaymentType({});
    }
  }, [data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          className={className}
          disabled={!enabled}
          error={!isEmpty(errors)}
          adornment={<PaymentIcon />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label={label ?? 'Tipo de Pagamento'}
          InputLabelProps={{
            readOnly: true,
          }}
          value={selectedPaymentType?.name ?? ''}
          required={required}
          helperText={
            !isEmpty(errors) ? (
              <FormHelperText error>{`${errors}`}</FormHelperText>
            ) : (
              ''
            )
          }
        />
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          onClose={handleClose}
        >
          <DialogContent>
            <StyledCrudTable
              title={'Seleção de Tipo de Pagamento'}
              modelActions={PaymentType.actions}
              columns={columns}
              rows={rows}
              page={page}
              setPage={(page) => setPage(page)}
              rowsPerPage={rowsPerPage}
              availableRowsPerPage={[3]}
              setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
              onOrderByChange={(orderBy) => setOrderby(orderBy)}
              orderBy={orderBy}
              setOrderBy={(value) => setOrderby(value)}
              searchBy={searchBy}
              setSearchBy={(value) => setSearchBy(value)}
              actions={{
                insert: {
                  icon: <AddBox />,
                  onClick: (id, data) => {
                    if (path) {
                      const pathArray = path.split('.');
                      pathArray.pop();
                      if (pathArray.length > 0) {
                        handleChange?.(
                          `${pathArray.join('.')}.paymentTypeName`,
                          data.name
                        );
                        handleChange?.(
                          `${pathArray.join('.')}.paymentTypeType`,
                          data.type
                        );
                        handleChange?.(
                          `${pathArray.join('.')}.unitFinanceId`,
                          undefined
                        );
                      }
                      setSelectedPaymentType(data);
                      handleChange?.(path, id);
                    }
                    onSuccess?.(id);
                    handleClose();
                  },
                  title: 'Vincular',
                  allowedActions: [PaymentType.actions.getAll],
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Hidden>
  );
};

export default SelectPaymentTypeDialogControl;
